import React from "react";

import JobListingItem from "../../../../../JobsPage/components/JobListingItem";
import { JobDetails } from "../utils/helpers";

interface MoreJobsProps {
	moreJobs: JobDetails[];
	currentJobId?: string;
	onJobSelect: (job: JobDetails) => void;
	onJobClick: (job: JobDetails) => void;
}

export function MoreJobs({ moreJobs, currentJobId, onJobSelect, onJobClick }: MoreJobsProps) {
	return (
		<div className="mt-12">
			<h2 className="text-lg font-semibold mb-4 font-plus-jakarta">More Job Opportunities</h2>
			<div>
				{moreJobs
					.filter((item) => item?._id !== currentJobId)
					.map((item, index) => {
						return (
							<JobListingItem
								key={index}
								job={{
									...item,
									logo: item.company?.logo_url ? item.company.logo_url : "/images/co-placeholder.png",
								}}
								onApply={() => onJobSelect(item)}
								onClick={() => onJobClick(item)}
								showCompany={true}
								titleClassName="text-base"
							/>
						);
					})}
			</div>
		</div>
	);
}
